import React from "react";
import { useTranslation } from "react-i18next";
import { Level } from "../../../../../common/level";
import { cutShort } from "../../../../../utils/stringUtil";
import Divider from "../../../../../common/divider/Divider";
import Box from "../../../../../common/box/Box";
import { select } from "../PreviewDocumentsUtils";

function Supplements({ state, url, setSelected }) {
  const { t } = useTranslation();
  /* const selected = (document, index) => {
    selector(document, index, null, null);
  }; */

  return (
    <>
      {state.supplements.length > 0 && (
        <div className="block">
          <Divider
            label={
              state.request.pdfFormName + " - " + t("requests.reviewDocuments.supplements.divider")
            }
          />
          {state.supplements.map((supplement, index) => (
            <Box
              key={"detail" + index}
              statusIndicatorPosition="left"
              statusIndicatorColor={supplement.color === null ? "warning" : supplement.color}
              className="is-size-5"
            >
              <Level>
                <Level.Side align="left">
                  {index + 1}. {cutShort(supplement.title, 130, "...")}
                </Level.Side>
                <Level.Side align="right">
                  <Level>
                    <Level.Side align="right" className="is-flex">
                      <button
                        onClick={() => select("supplements", index, null, null, setSelected)}
                        /* to={{
                          pathname: `${url}/supplements/${index}`,
                          state: { state },
                        }} */
                        rel="noopener noreferrer"
                        className="button is-pulled-left"
                      >
                        {t("requests.reviewDocuments.attachments.preview")}
                      </button>
                    </Level.Side>
                  </Level>
                </Level.Side>
              </Level>
            </Box>
          ))}
        </div>
      )}
    </>
  );
}

export default Supplements;
